import { BaseActor } from "./BaseActor";

export class ActorState {
  public onActivate: () => Promise<boolean> = async () => true;
  public onDeactivate: () => Promise<void> = async () => { };
  public actor: BaseActor | null = null;
  private isActive = false;
  public isTriggerable: boolean = false;
  public exclusive: boolean = true;
  constructor(public name: string) { }
  public get active() {
    return this.isActive;
  }
  public async activate(): Promise<boolean> {
    if (this.isActive) {
      return true;
    }
    if (this.exclusive && this.actor) {
      for (const state of this.actor.states) {
        if (state.active && state !== this && state.exclusive) {
          await state.deactivate();
        }
      }
    }
    const ok = await this.onActivate();
    if (ok) {
      this.isActive = true;
    }
    return ok;
  }
  public async deactivate(): Promise<void> {
    if (!this.isActive) {
      return;
    }
    this.onDeactivate();
    this.isActive = false;
  }
}
